import { ProfileImage } from "thrive-components"
import { ChatMenuItem } from "./ChatMenuItem.Service"
import { CAS } from "../../service/ChatConfig.Service"

const ChatMenuListItem = ({chatItem}:{chatItem: ChatMenuItem}) => {
    return <li className={`chat-menu-item ${chatItem.isNewChat && 'new-item'}`} id={`chat-menu-item-${String(chatItem.id)}`}>
        <button
            className="chat-menu-item-button"
            onClick={chatItem.openChat}
            type='button'
            tabIndex={chatItem.isNewChat ? -1 : 0}
            disabled={chatItem.buttonIsDisabled ? true : undefined}
            name={chatItem.chatName}
            aria-label={chatItem.isNewChat ? '' : chatItem.chatName }
        >
        
            <span className="profile-pic">   
                <ProfileImage
                    className="contact-image" 
                    profileImageUrl={chatItem.profilePicUri}
                    accessToken={CAS.getAccessToken() as string}
                    isStaticAsset={chatItem.id === "0"}
                />
            </span>
            <span className="menu-body">
                <span className="title-wrapper">
                    <span className="title">
                        {chatItem.chatName}
                    </span>
                     <span className="menu-meta">
                        {chatItem.chatTimeStamp}
                    </span>
                </span>
                
                <span className="body">
                    {chatItem.chatLastMessagePlainText}
                </span>
            </span>
           
        </button>
    </li>
}

export default ChatMenuListItem;